module.exports = __webpack_public_path__ + "static/media/study 220411.d9976495.png";